import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const OfferPowerfulActionsImage = () => {
  const data = useStaticQuery(graphql`
    query {
      OfferPowerfulActionsImage: file(
        relativePath: { eq: "platform/offers/offer-powerful-actions.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.OfferPowerfulActionsImage.childImageSharp.fluid}
      alt="Offer Powerful Actions Image"
    />
  )
}

export default OfferPowerfulActionsImage
